import { Button, Icon, Theme, useStyles } from 'bold-ui'
import { BreadcrumbNav } from 'components/breadcrumb'
import { BadgeNotificacao } from 'components/notificacao/BadgeNotificacao'
import { UserHeader } from 'components/user/UserHeader'
import { TipoTopicoNotificacaoEnum } from 'graphql/types.generated'
import React, { CSSProperties } from 'react'
import { useNotificacaoCount } from 'view/notificacao/hooks/useNotificacaoCount'

import { PageContainer } from './PageContainer'
import { SIDE_MENU_WIDTH } from './SideMenu'

export const Z_INDEX_MAIN_HEADER = 12

export interface MainHeaderProps {
  hasBreadcrumbs: boolean
  onModulosClick(e: React.MouseEvent): void
}

/**
 * Header da aplicação, contendo a logo do e-sus, menu do usuário e breadcrumbs.
 */
export const MainHeader = (props: MainHeaderProps) => {
  const { hasBreadcrumbs, onModulosClick } = props
  const { classes, css } = useStyles(createStyles)

  const hasNotificacoes = useNotificacaoCount(Object.values(TipoTopicoNotificacaoEnum)) > 0

  return (
    <div className={classes.wrapper}>
      <UserHeader />

      {hasBreadcrumbs && (
        <div className={classes.container}>
          <PageContainer fluid>
            <div className={css(classes.breadcrumbs)} data-cy='AppHeader.breadcrumbs'>
              <span className={classes.modulos}>
                <Button size='small' skin='ghost' kind='primary' onClick={onModulosClick}>
                  <div className={classes.badgeContainer}>
                    <div className={classes.badge} data-badge='notificacao'>
                      <BadgeNotificacao value={hasNotificacoes} type='small' />
                    </div>
                    <Icon icon='module' style={{ marginRight: '0.5rem' }} />
                  </div>
                  Módulos
                </Button>
              </span>

              <BreadcrumbNav />
            </div>
          </PageContainer>
        </div>
      )}
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  wrapper: {
    position: 'relative',
    zIndex: Z_INDEX_MAIN_HEADER,
    boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 1px -1px rgba(0, 0, 0, 0.04)',
  } as CSSProperties,
  container: {
    borderBottom: '1px solid ' + theme.pallete.divider,
    background: theme.pallete.surface.main,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: SIDE_MENU_WIDTH,
    },
  },
  breadcrumbs: {
    display: 'flex',
    alignItems: 'center',
  },
  modulos: {
    marginRight: '0.5rem',
    paddingRight: '0.5rem',
    borderRight: `1px solid ${theme.pallete.divider}`,
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
    '&:hover [data-badge="notificacao"]': {
      borderColor: theme.pallete.gray.c90,
    },
  },
  badgeContainer: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
  } as CSSProperties,
  badge: {
    position: 'absolute',
    top: '-0.5px',
    right: '8px',
    border: `2px solid ${theme.pallete.surface.main}`,
    borderRadius: '12px',
    margin: '-2px',
    display: 'inline-flex',
    transition: 'border-color 0.2s ease',
  } as CSSProperties,
})
